/*! images */
$(document).ready(function () {

    // FANCYBOX
    $('[data-fancybox]').fancybox({
        caption: function (instance, item) {
            return $(this).closest('figure').find('figcaption').html();
        }
    });
    $('a.banner').fancybox({
        caption: function (instance, item) {
            return $(this).children('.banner-caption').html();
        }
    });

    var featureBandImageLinks = $('.img-feature-band .feature-container > a > img').parent('a').addClass('image-link');

});